<!--  -->
<template>
  <div v-loading="loading">
    <!-- <div class="back">
      <img
        src="https://baike-med-1256891581.file.myqcloud.com/2021043/76032200-9dcf-11eb-ae0e-21d0e54b35ac_0.png"
        class="details-img"
        @click="Goback"
      />
      <div class="details-return" @click="Goback">返回</div>
    </div> -->
    <!-- 头部 -->
    <div class="user-data">
      <div class="name">
        <el-avatar :size="64" :src="userData.user.user_img || avatarDefault"></el-avatar>
        <span class="behalf">
          {{ userData.doctor.doctor_name ? userData.doctor.doctor_name : '' }}
        </span>
        <span class="username" :title="userData.user.nick_name || userData.open_id">
          {{ userData.user.nick_name || userData.open_id || '-' }}
        </span>
      </div>
      <div class="user-label">
        <div class="user-label-header">
          <span>医院</span>
          <span>科室</span>
          <span>标签</span>
          <span>关联代表</span>
        </div>
        <div class="user-label-content">
          <span>{{ userData.doctor.hospital ? userData.doctor.hospital : '' }}</span>
          <span>{{ userData.doctor.department ? userData.doctor.department : '' }}</span>
          <span>
            <p v-for="(item, i) in userData.user.tag" :key="i">
              {{ item }}
            </p>
          </span>
          <span>
            <!-- {{ userData.doctor.representative_name ? userData.doctor.representative_name : '' }} -->
            <el-button type="text" @click="handleJumpBehalf(userData.doctor.representative_id)">
              {{ userData.doctor.representative_name ? userData.doctor.representative_name : '' }}
            </el-button>
          </span>
        </div>
      </div>
    </div>
    <!-- 用户消息内容 -->
    <div class="content" v-if="userMessageList.length > 0">
      <div class="content-name">
        与{{ userData.user.nick_name || userData.open_id || '-' }}的聊天记录
      </div>
      <div v-for="(item, index) in userMessageList" :key="item.msg_id">
        <!-- 用户发送的消息 -->
        <div class="content-msg" v-if="item.is_send === 2">
          <el-avatar
            shape="square"
            :size="48"
            :src="item.user.user_img || avatarDefault"
          ></el-avatar>
          <div class="reply">
            <div class="re-con" v-if="item.msg_type === 1">
              <div v-for="(content1, index1) in item.msg_content" :key="index1">
                {{ content1 }}
              </div>
              <!--              {{ item.msg_content }}-->
              <!--              <span></span>-->
            </div>
            <div v-if="item.msg_type === 2">
              <img width="100" height="140" :src="item.media_url" alt="" />
            </div>
            <div v-if="item.msg_type === 3">
              <Mvideo :name="item.msg_id" width="320" height="200" :src="item.media_url"></Mvideo>
            </div>
            <div v-if="item.msg_type === 4">
              <Maudio block ref="audio" :src="item.media_url" showduration></Maudio>
            </div>
            <div class="re-con" v-if="item.msg_type === 5">
              <el-link target="_blank" :href="item.msg_content" type="primary" :underline="false">
                {{ item.msg_content }}
              </el-link>
            </div>
            <div v-if="item.msg_type === 6" style="width: 280px; height: 136px">
              <!-- <p>所处地址：{{ Object.values(JSON.parse(item.msg_content))[0] }}</p>
              <p>经度坐标：{{ Object.values(JSON.parse(item.msg_content))[1] }}</p>
              <p>维度坐标：{{ Object.values(JSON.parse(item.msg_content))[2] }}</p> -->
              <Maps :items="item" :index="index"></Maps>
            </div>
            <div class="re-con" v-if="item.msg_type === -1">
              【收到不支持的消息类型，暂无法显示】
              <span></span>
            </div>
            <span>{{ item.create_time | parseTime }}</span>
          </div>
          <el-dropdown trigger="click" @command="handleCommand">
            <div class="el-dropdown-link">
              <div class="el-icon-chat-dot-round reply-button"></div>
            </div>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="{ ...item, command: 'collect' }">收藏</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <!-- 回复的消息 -->
        <div class="reply-message" v-if="item.is_send === 1">
          <div class="reply-message-left">
            <div class="re-con">
              <div v-for="(content1, index1) in item.msg_content" :key="index1">
                {{ content1 }}
              </div>
              <div
                class="article-container"
                v-for="(content2, index2) in item.article"
                :key="index2"
              >
                <img :src="content2.cover_url" alt="" />
                <div class="title-container">
                  <div class="title">文章标题：</div>
                  <div class="content" :title="content2.title">{{ content2.title }}</div>
                </div>
              </div>
            </div>
            <div class="user-time">{{ item.create_time | parseTime }}</div>
          </div>
          <div>
            <el-avatar
              shape="square"
              :size="50"
              src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
            ></el-avatar>
          </div>
        </div>
      </div>
    </div>
    <!-- 分页 -->
    <div style="margin-top: 20px; float: right" v-if="userMessageList.length > 0">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page_index"
        :page-size="page_size"
        :page-sizes="g_pageSizesConfig"
        layout="total,sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import Mvideo from '@/components/video/index.vue';
import Maudio from '@/components/audio/audio.vue';
import { GetUserMsgList, CollectMsg } from '@/api/messageManagement.js';
import { parseTime } from '@/utils/time.js';
import Maps from '@/views/messageManagement/messageList/components/maps.vue';
export default {
  name: 'UserMessageList',
  components: {
    Mvideo,
    Maudio,
    Maps,
  },
  data() {
    return {
      date: 0,
      loading: false,
      content: '',
      page_index: 1,
      page_size: this.g_pageSizeDefault,
      total: 0,
      userData: {
        msg_content: '',
        user: {
          tag: [],
          user_img: '',
          nick_name: '',
        },
        doctor: {
          doctor_name: '',
          hospital: '',
          department: '',
          representative_id: '',
          representative_name: '',
        },
      },
      userMessageList: [],
      // replyMessageList: [],
      avatarDefault:
        'https://baike-med-1256891581.file.myqcloud.com/2021124/c57df790-5d70-11ec-a3f4-354087f4d05d_0.png',
    };
  },
  created() {
    this.page_size = this.g_pageSizeDefault;
    this.date = +new Date();
    this.getList();
  },
  methods: {
    parseTime,
    handleJumpBehalf(val) {
      this.g_tourl(`/saas/representDetaill.html?id=${val}&type=newWindow`, { open: true });
    },
    handleSizeChange(val) {
      this.page_size = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.page_index = val;
      this.getList();
    },
    handleCommand(val) {
      // 选择收藏与回复
      if (val.command === 'collect') {
        if (val.is_collect === 1) {
          this.$message.error('该消息已被收藏，无需再次收藏');
          return false;
        }
        if (val.is_collect === 2) {
          CollectMsg({ msg_id: val.msg_id })
            .then(() => {
              this.getList();
              this.$message.success('收藏成功');
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }
      }
    },

    getList() {
      this.loading = true;
      GetUserMsgList({
        open_id: this.$route.query.open_id,
        page_size: this.page_size,
        time_limit: this.date,
        page_index: this.page_index,
      })
        .then((res) => {
          this.userData = res.msgs[0] || this.userData;
          this.total = res.total;
          const arr = res.msgs;
          this.userMessageList = arr.map((item) => ({ ...item, inputShow: false }));
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err.message);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.back {
  position: relative;
  height: 80px;
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #303133;
  // border-bottom: 1px solid #edeff2;
  .details-img {
    position: absolute;
    top: 32.5px;
    left: 0;
    width: 24px;
    height: 24px;
    transform: rotateY(180deg);
  }
  .details-img:hover {
    color: rgb(47, 150, 255);
  }
  .details-return {
    position: absolute;
    top: 36px;
    width: 44px;
    height: 22px;
    left: 28px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #606266;
    letter-spacing: 0;
    cursor: pointer;
  }
  .details-return:hover {
    color: rgb(47, 150, 255);
  }
}
.user-data {
  display: flex;
  border: 1px solid #edeff2;
  border-radius: 8px;
  min-width: 1144px;
  // height: 152px;
  .name {
    width: 17%;
    // height: 100%;
    border-right: 1px solid #edeff2;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .behalf {
      height: 26px;
      font-size: 18px;
      color: #313233;
      letter-spacing: 0;
      text-align: center;
      line-height: 26px;
    }
    .username {
      font-size: 14px;
      color: #303133;
      letter-spacing: 0;
      line-height: 22px;
      max-width: 100%;
      padding: 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .user-label {
    // height: 152px;
    width: 100%;
    .user-label-header {
      text-align: center;
      height: 45px;
      box-sizing: border-box;
      border-bottom: 1px solid #edeff2;
      padding: 0 25px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      color: #313233;
      letter-spacing: 0;
      line-height: 22px;
      span {
        width: 25%;
      }
    }
    .user-label-content {
      text-align: center;
      padding: 10px 25px;
      min-height: 107px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      span {
        width: 25%;
      }
      span:nth-child(3) p {
        padding: 5px 0;
      }
    }
  }
}
.content {
  margin-top: 20px;
  box-sizing: border-box;
  padding: 0 20px;
  .content-name {
    height: 70px;
    line-height: 70px;
    border-bottom: 1px solid #edeff2;
    font-size: 20px;
    color: #313233;
    letter-spacing: 0;
    text-align: left;
  }
  .content-msg {
    margin: 30px 0 15px 0;
    display: flex;
    .reply {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin: 0 7px 0 18px;
      .re-con {
        // padding: 0 20px;
        // color: #313233;
        // min-width: 96px;
        // // text-align: center;
        // min-height: 48px;
        // line-height: 48px;
        // border: 1px solid #dcdee3;
        // box-shadow: 0 4px 10px 0 rgba(49, 50, 54, 0.15);
        // border-radius: 4px;
        // position: relative;
        color: #313233;
        max-width: 400px;
        min-height: 48px;
        padding: 0 15px;
        line-height: 48px;
        border: 1px solid #dcdee3;
        box-shadow: 0 4px 10px 0 rgb(49 50 54 / 15%);
        border-radius: 4px;
        position: relative;
        word-wrap: break-word;
        span {
          width: 24px;
          height: 24px;
          display: block;
          position: absolute;
          left: -13px;
          top: 0px;
          transform: scaleY(-1) rotate(45deg);
          background: #ffffff;
          border-left: 1px solid #dcdee3;
          border-bottom: 1px solid #dcdee3;
          border-radius: 2px;
        }
        a {
          width: 100%;
          display: inline-block;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
      span {
        text-align: left;
        margin-top: 10px;
        font-size: 14px;
        color: #939599;
        line-height: 20px;
      }
    }
    .el-dropdown {
      align-self: flex-end;
      margin-bottom: 26px;
      width: 24px;
      height: 24px;
      .reply-button {
        width: 24px;
        height: 24px;
        font-size: 24px;
        color: #d2d4d9;
        cursor: pointer;
      }
    }
  }
  .send-content {
    .el-textarea {
      height: 160px;
      ::v-deep.el-textarea__inner {
        resize: none;
        height: 160px;
      }
    }
  }
  .send-button {
    margin-top: 15px;
    display: flex;
    justify-content: flex-end;
  }
}
.reply-message {
  margin-top: 60px;
  display: flex;
  justify-content: flex-end;
  .reply-message-left {
    display: flex;
    flex-direction: column;
    margin-right: 20px;
    .re-con {
      // white-space: normal;
      align-self: flex-end;
      color: #313233;
      max-width: 400px;
      // text-align: center;
      min-height: 48px;
      padding: 0 15px;
      line-height: 48px;
      border: 1px solid #dcdee3;
      box-shadow: 0 4px 10px 0 rgb(49 50 54 / 15%);
      border-radius: 4px;
      position: relative;
      word-wrap: break-word;
      .article-container {
        width: 350px;
        display: flex;
        margin: 10px 0;
        img {
          width: 150px;
          height: 100px;
          flex: 0 0 150px;
        }
        .title-container {
          flex: 1;
          margin-left: 10px;
          .title {
            font-size: 18px;
            font-weight: bold;
          }
          .content {
            width: 190px;
            padding: 0;
            margin: 10px 0;
            line-height: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
    }
    .user-content {
      line-height: 28px;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 10px;
      background: #f2f4f7;
      border-radius: 2px;
      color: #939599;
      text-align: center;
      line-height: 20px;
      margin-top: 15px;
      span {
        line-height: 28px;
      }
    }
    .user-time {
      color: #939599;
      line-height: 20px;
      text-align: right;
      margin-top: 8px;
    }
  }
}
</style>
